<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PM497t/tc-custom/9781781012048.jpg?1705018937067" alt="This image is the cover for the book Grow Your Own Cake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grow Your Own Cake
      </h1>
      <p class="bookDescription body article font2">
        <b>“Shows how garden produce—from berries to beetroot—can be used to make delicious cakes, biscuits and tarts . . . plenty of sensible grow-your-own advice.” —<i>Two Thirsty Gardeners</i></b><br/><br/>The veg plot and fruit garden are the new starting points for the healthiest, best cakes—and with this book you can grow and bake fifty of the tastiest cakes with most of the ingredients not far from your fingertips, all the way from sowing the seeds to cutting the cake. Choose the best baking varieties for each recipe: grow long sweet parsnips to grate into parsnip cake, and short baby parsnips for a tarte-tatin. From blackcurrants for meringues to lavender for shortbread, from sweet potatoes to spinach, cherries to chillies, beetroot to basil, and ginger to garlic, all manner of vegetables, fruit, herbs and flowers can be found in a baker’s kitchen garden.<br/><br/>“The photos are delicious, the recipes straightforward and easy to follow. You can pick your cakes by season depending on what fruit or vegetables you have to hand.” —<i>The English Garden</i><br/><br/>“The recipes put interesting vegetables and fruits centre stage and turn old cliches of sweet and savoury upside down.” —<i>The Women’s Room</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Farrell, Jason Ingram
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aurum Press Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19c0a33a